/**
 * @prettier
 */
export const DeliveryProvidersPhoneNumber = {
    UBER_DAAS: '+5215590354662',
    RAPPI_CARGO: '+5723691694',
} as const;

export type DeliveryProviderPhoneNumber = typeof DeliveryProvidersPhoneNumber[keyof typeof DeliveryProvidersPhoneNumber];
